module.exports = __webpack_public_path__ + "img/title_4.e92c63e5.png";